export default "__VITE_ASSET__DOCorkd5__"